module.exports = __webpack_public_path__ + "img/guanghuan.269bee7f.png";